import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { CustomPanel, Loading, PageHeader } from '../../../../../components'
import { getMissingProductByDeliveryId } from '../../../../../services/api/https/deliveries/delivery.http'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import FaltaDataTable from './FaltaDataTable'

function Faltas({ history, dispatch }) {
  // Vars
  const {
    location: {
      state: { delivery_id, identifier, nomeFantasia, delivery_step_id, fleet_id },
    },
  } = history

  // Hooks
  const [ocorrencias, setOcorrencias] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getEntregaComOcorrencias()
  }, [delivery_id, fleet_id])

  // Helpers
  const getEntregaComOcorrencias = async () => {
    try {
      const fetchedOcorrencias = await getMissingProductByDeliveryId(delivery_id)

      setOcorrencias(fetchedOcorrencias)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Render
  return (
    <React.Fragment>
      <PageHeader>
        Ocorrências de Falta&nbsp;
        <strong>
          {nomeFantasia} - {identifier}
        </strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div>
            {isLoading ? (
              <div className="text-center">
                <Loading />
              </div>
            ) : (
              <FaltaDataTable
                ocorrencias={ocorrencias}
                setOcorrencias={setOcorrencias}
                getEntregaComOcorrencias={getEntregaComOcorrencias}
                dispatch={dispatch}
                delivery_id={delivery_id}
                delivery_step_id={delivery_step_id}
                nomeFantasia={nomeFantasia}
                identifier={identifier}
              />
            )}
          </div>
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

export default connect()(withRouter(Faltas))
